import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "w-fit mx-auto"
}

import { PropType } from 'vue';
import { AdUnit } from '@/common/adSlots';
import { showClouDNSAds } from '@/common/dateTime';
import ResponsiveNitroPayAd from '@/components/ads/ResponsiveNitroPayAd.vue';
import ClouDNSAd from '@/components/ads/ClouDNSAd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdUnit',
  props: {
  config: {
    type: Object as PropType<AdUnit>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



// Sold half of the ad slots to ClouDNS
const randomNumber = Math.floor(Math.random() * 100);
const showClouDNS = randomNumber < 50;

function getSizes(size: 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'): string[][] {
  switch (size) {
    case 'default':
      return props.config.default;
    case 'sm':
      return props.config.sm ?? getSizes('default');
    case 'md':
      return props.config.md ?? getSizes('sm');
    case 'lg':
      return props.config.lg ?? getSizes('md');
    case 'xl':
      return props.config.xl ?? getSizes('lg');
    case '2xl':
      return props.config['2xl'] ?? getSizes('xl');
    default:
      return [];
  }
}

return (_ctx: any,_cache: any) => {
  return (!_unref(showClouDNSAds)() || !showClouDNS)
    ? (_openBlock(), _createBlock(ResponsiveNitroPayAd, {
        key: 0,
        config: __props.config
      }, null, 8, ["config"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ClouDNSAd, {
          class: "sm:hidden",
          sizes: getSizes('default')
        }, null, 8, ["sizes"]),
        _createVNode(ClouDNSAd, {
          class: "hidden sm:block md:hidden",
          sizes: getSizes('sm')
        }, null, 8, ["sizes"]),
        _createVNode(ClouDNSAd, {
          class: "hidden md:block lg:hidden",
          sizes: getSizes('md')
        }, null, 8, ["sizes"]),
        _createVNode(ClouDNSAd, {
          class: "hidden lg:block xl:hidden",
          sizes: getSizes('lg')
        }, null, 8, ["sizes"]),
        _createVNode(ClouDNSAd, {
          class: "hidden xl:block 2xl:hidden",
          sizes: getSizes('xl')
        }, null, 8, ["sizes"]),
        _createVNode(ClouDNSAd, {
          class: "hidden 2xl:block",
          sizes: getSizes('2xl')
        }, null, 8, ["sizes"])
      ]))
}
}

})